import {pnc_url_pnc} from '../config/constants';
import axios from 'axios';
class FormAPI{
static sendInformationLocation(popkey,boat_immatriculation,boat_name,date,time,port,adress){
    return axios.post(pnc_url_pnc + '/boat/postlocation',{
      headers: {
        "Authorization":'555',
        'Content-Type' : 'application/json',
        "User-Key": popkey
      },
      popkey:popkey,
        location:{
          boat_immatriculation:boat_immatriculation,
          boat_name:boat_name,
          date:date,
          time:time,
          port:port,
          adress:adress

        }
    }
  )
}

static getDeclarationBoat(popkey){
  return axios.get(pnc_url_pnc + '/boat/getdeclaration',{
  headers: {
       'Content-Type': 'application/json',
       Authorization: '555',
       'User-Key': popkey,
     },
    params:{
    }
  }
  );
}


}

export default FormAPI;
